<p-select
  [options]="variantGroups"
  [group]="true"
  [multiple]="true"
  scrollHeight="400px"
  [disabled]="disabled()"
  [ngModel]="selectedVariants"
  (ngModelChange)="selectedVariants = $event; onVariantChange()"
  [appendTo]="appendTo()"
  panelStyleClass="p-select-checkbox-options"
  placeholder="All Quote Types"
  [class]="required() && !selectedVariants?.length ? 'has-error' : ''"
>
  <ng-template #item let-option>
    <p-checkbox
      [ngModel]="isSelected(option.value)"
      [binary]="true"
      [readonly]="true"
      [tabindex]="-1"
    />
    <span>{{ option.label }}</span>
  </ng-template>

  <ng-template #selectedItem>
    <app-selected-chips
      [items]="selectedVariants"
      [label]="chipLabel"
      [removable]="!disabled()"
      (removeItem)="removeVariant($event)"
    />
  </ng-template>
</p-select>
